import {
  INTRO_STARTED,
  INTRO_ADVANCED,
  INTRO_COMPLETED
} from './constants';

export function startIntro(){
  return {type:INTRO_STARTED}
}

export function advanceIntro(){
  return {type:INTRO_ADVANCED}
}

export function completeIntro(){
  return {type:INTRO_COMPLETED}
}



// WEBPACK FOOTER //
// ./src/shared/redux/intro/actions.js